import { EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { SpartaxAuftragskunde } from "src/app/data/dto/spartax/spartax-auftragskunde.dto";
import { SpartaxFormModelDto, SpartaxFormModelDtoUtil } from "src/app/data/dto/spartax/spartax-form-model.dto";

export abstract class SpartaxFormStepBaseComponent {
    @Input()
    model: SpartaxFormModelDto;

    @Output()
    modelChange = new EventEmitter<SpartaxFormModelDto>();

    @Input()
    edit: boolean;

    @ViewChild('formElement')
    ngForm!: NgForm;

    public get hauptkunde(): SpartaxAuftragskunde {
        return SpartaxFormModelDtoUtil.getHauptkundeAuftragskunde(this.model);
    }

    public get partner(): SpartaxAuftragskunde {
        return SpartaxFormModelDtoUtil.getPartnerAuftragskunde(this.model);
    }

    formIsValid() {
        return this.ngForm?.valid ?? true;
    }

    markAllControlsAsTouched() {
        if (this.ngForm) {
            for (const control in this.ngForm.controls) {
                this.ngForm.controls[control].markAsTouched();
            }
        }
    }

    onShowFormStep() {
        // Override in derived classes if needed
    }

    onHideFormStep() {
        // Override in derived classes if needed
    }
}
